/**
 * MyDesignation Wishlist skin for /apps/iwish
 * Rebuilds chrome + cards to match Items/Boards mock; keeps iWish APIs.
 */
(function () {
  if (!/\/apps\/iwish/i.test(window.location.pathname)) return;

  const BOARDS_KEY = 'myd_wish_boards_v1';
  const ICONS = {
    back: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 7h15l-1.5 9h-12L6 7z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M6 7L5 3H2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="9" cy="20" r="1.3" fill="currentColor"/><circle cx="18" cy="20" r="1.3" fill="currentColor"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" stroke="currentColor" stroke-width="1.6"/></svg>',
    grid: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.2" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="3" width="7" height="7" rx="1.2" stroke="currentColor" stroke-width="1.6"/><rect x="3" y="14" width="7" height="7" rx="1.2" stroke="currentColor" stroke-width="1.6"/><rect x="14" y="14" width="7" height="7" rx="1.2" stroke="currentColor" stroke-width="1.6"/></svg>',
    board: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7.5A2.5 2.5 0 0 1 6.5 5H10l2 2h5.5A2.5 2.5 0 0 1 20 9.5v7A2.5 2.5 0 0 1 17.5 19h-11A2.5 2.5 0 0 1 4 16.5v-9z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    pencil: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20h9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    bell: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9.5 17a2.5 2.5 0 0 0 5 0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  };

  const productCache = new Map();
  const enrichQueue = [];
  let enrichActive = 0;
  const ENRICH_CONCURRENCY = 2;
  let searchJsPromise = null;
  let enrichObserver = null;

  const state = {
    tab: 'items',
    ready: false,
    hydrated: false,
    editingBoardId: null,
    painting: false,
  };

  function isLoggedIn() {
    const cust = window.iWishData?.cust;
    return !!(cust && String(cust).trim() && String(cust) !== '0');
  }

  function returnTo() {
    return `${window.location.pathname}${window.location.search}` || '/apps/iwish?show=account';
  }

  function cartCount() {
    try {
      return Number(window.Shopify?.cart?.item_count) ||
        Number(document.querySelector('.cart-count-bubble span')?.textContent) ||
        0;
    } catch (_) {
      return 0;
    }
  }

  function readBoards() {
    try {
      const raw = localStorage.getItem(BOARDS_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function writeBoards(boards) {
    localStorage.setItem(BOARDS_KEY, JSON.stringify(boards));
  }

  function ensureDefaultBoard(boards) {
    if (boards.some((b) => b.isDefault)) return boards;
    return [{ id: 'default', name: 'Main Wishlist', isDefault: true, productIds: [] }, ...boards];
  }

  function pruneBoardMembership(boards, liveIds) {
    const live = new Set((liveIds || []).map(String).filter(Boolean));
    return boards.map((b) => {
      if (b.isDefault) return { ...b, productIds: [] };
      return {
        ...b,
        productIds: (b.productIds || []).map(String).filter((id) => live.has(id)),
      };
    });
  }

  function customAssignedIds(boards) {
    const ids = new Set();
    boards.forEach((b) => {
      if (b.isDefault) return;
      (b.productIds || []).forEach((id) => ids.add(String(id)));
    });
    return ids;
  }

  function currentBoardIdForProduct(productId, boards) {
    const id = String(productId || '');
    if (!id) return 'default';
    const hit = boards.find((b) => !b.isDefault && (b.productIds || []).map(String).includes(id));
    return hit?.id || 'default';
  }

  function moveProductToBoard(productId, targetBoardId) {
    const id = String(productId || '');
    if (!id) return;
    let boards = ensureDefaultBoard(readBoards());
    const liveIds = collectWishlistThumbs().map((t) => t.id).filter(Boolean);
    boards = pruneBoardMembership(boards, liveIds);

    boards = boards.map((b) => {
      if (b.isDefault) return b;
      const next = (b.productIds || []).map(String).filter((pid) => pid !== id);
      if (String(b.id) === String(targetBoardId)) next.push(id);
      return { ...b, productIds: next };
    });

    writeBoards(boards);
  }

  function thumbsForBoard(board, thumbs, boards) {
    const assigned = customAssignedIds(boards);
    if (board.isDefault) {
      return thumbs.filter((t) => t.id && !assigned.has(String(t.id)));
    }
    const set = new Set((board.productIds || []).map(String));
    return thumbs.filter((t) => t.id && set.has(String(t.id)));
  }

  function uid() {
    return `b_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
  }

  function handleFromHref(href) {
    if (!href) return '';
    try {
      const path = new URL(href, window.location.origin).pathname;
      const m = path.match(/\/products\/([^/?#]+)/i);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (_) {
      return '';
    }
  }

  function productIdFromItem(item) {
    const btn = item.querySelector('.iwishRemoveBtn');
    return (
      btn?.getAttribute('data-product') ||
      btn?.getAttributeNode?.('data-product')?.value ||
      item.getAttribute('data-product') ||
      ''
    );
  }

  function collectWishlistThumbs() {
    return [...document.querySelectorAll('.iwishItem')].map((item) => {
      const img = item.querySelector('.iwishImgWrap img');
      const link = item.querySelector('.iwishImgWrap a, .iwishMeta-title a');
      return {
        id: String(productIdFromItem(item) || ''),
        src: img?.getAttribute('src') || '',
        alt: img?.getAttribute('alt') || '',
        href: link?.getAttribute('href') || '#',
        handle: handleFromHref(link?.getAttribute('href')),
      };
    }).filter((t) => t.src);
  }

  function injectShell(wrapper) {
    if (document.querySelector('.myd-wl-tabs')) return;

    const tabs = document.createElement('div');
    tabs.className = 'myd-wl-tabs';
    tabs.innerHTML = `
      <button type="button" class="myd-wl-tabs__btn is-active" data-myd-wl-tab="items">Items(<span data-myd-wl-count>0</span>)</button>
      <button type="button" class="myd-wl-tabs__btn" data-myd-wl-tab="boards">Boards</button>
    `;

    const itemsPanel = document.createElement('div');
    itemsPanel.className = 'myd-wl-panel';
    itemsPanel.dataset.mydWlPanel = 'items';

    const boardsPanel = document.createElement('div');
    boardsPanel.className = 'myd-wl-panel';
    boardsPanel.dataset.mydWlPanel = 'boards';
    boardsPanel.hidden = true;

    const empty = document.createElement('div');
    empty.className = 'myd-wl-empty';
    empty.dataset.mydWlEmpty = '';
    empty.hidden = true;

    const products = wrapper.querySelector('.iwishProducts');
    wrapper.prepend(tabs);
    if (products) {
      itemsPanel.appendChild(empty);
      products.parentNode.insertBefore(itemsPanel, products);
      itemsPanel.appendChild(products);
    } else {
      itemsPanel.appendChild(empty);
      wrapper.appendChild(itemsPanel);
    }
    wrapper.appendChild(boardsPanel);

    const modal = document.createElement('div');
    modal.className = 'myd-wl-modal';
    modal.hidden = true;
    modal.dataset.mydWlModal = '';
    modal.innerHTML = `
      <div class="myd-wl-modal__card" role="dialog" aria-modal="true" aria-label="Create Your Board">
        <div class="myd-wl-modal__icon">${ICONS.pencil}</div>
        <h2 class="myd-wl-modal__title" data-myd-wl-modal-title>Create Your Board</h2>
        <p class="myd-wl-modal__text" data-myd-wl-modal-text>Enter a name for your wishlist Board</p>
        <input class="myd-wl-modal__input" type="text" data-myd-wl-board-name placeholder="Goa Outfits" maxlength="60" />
        <button type="button" class="myd-wl-btn" data-myd-wl-board-save>Create</button>
        <button type="button" class="myd-wl-btn myd-wl-btn--ghost" data-myd-wl-board-cancel>Cancel</button>
      </div>
    `;
    document.body.appendChild(modal);

    tabs.addEventListener('click', (event) => {
      const btn = event.target.closest?.('[data-myd-wl-tab]');
      if (!btn) return;
      setTab(btn.getAttribute('data-myd-wl-tab'));
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal.querySelector('[data-myd-wl-board-cancel]')?.addEventListener('click', closeModal);
    modal.querySelector('[data-myd-wl-board-save]')?.addEventListener('click', saveBoardFromModal);

    // Move-to-board sheet
    if (!document.querySelector('[data-myd-wl-move-modal]')) {
      const move = document.createElement('div');
      move.className = 'myd-wl-modal myd-wl-move-modal';
      move.hidden = true;
      move.dataset.mydWlMoveModal = '';
      move.innerHTML = `
        <div class="myd-wl-modal__card myd-wl-move-modal__card" role="dialog" aria-modal="true" aria-label="Move to board">
          <h2 class="myd-wl-modal__title">Move to board</h2>
          <p class="myd-wl-modal__text">Choose where this item should live</p>
          <div class="myd-wl-move-list" data-myd-wl-move-list></div>
          <button type="button" class="myd-wl-btn myd-wl-btn--ghost" data-myd-wl-move-cancel>Cancel</button>
        </div>
      `;
      document.body.appendChild(move);
      move.addEventListener('click', (event) => {
        if (event.target === move) closeMoveSheet();
      });
      move.querySelector('[data-myd-wl-move-cancel]')?.addEventListener('click', closeMoveSheet);
    }
  }

  function openMoveSheet(productId) {
    const id = String(productId || '');
    if (!id) return;
    const move = document.querySelector('[data-myd-wl-move-modal]');
    const list = move?.querySelector('[data-myd-wl-move-list]');
    if (!move || !list) return;

    const thumbs = collectWishlistThumbs();
    let boards = pruneBoardMembership(ensureDefaultBoard(readBoards()), thumbs.map((t) => t.id));
    writeBoards(boards);

    const customs = boards.filter((b) => !b.isDefault);
    if (!customs.length) {
      list.innerHTML = `
        <p class="myd-wl-move-empty">Create a board first, then move items into it.</p>
        <button type="button" class="myd-wl-btn" data-myd-wl-move-create>Create Board</button>
      `;
      list.querySelector('[data-myd-wl-move-create]')?.addEventListener('click', () => {
        closeMoveSheet();
        setTab('boards');
        openCreateModal();
      });
      move.hidden = false;
      return;
    }

    const current = currentBoardIdForProduct(id, boards);
    list.innerHTML = boards
      .map((b) => {
        const active = String(b.id) === String(current);
        return `
          <button type="button" class="myd-wl-move-option${active ? ' is-active' : ''}" data-myd-wl-move-to="${escapeAttr(b.id)}">
            <span>${escapeHtml(b.name)}${b.isDefault ? ' (Default)' : ''}</span>
            ${active ? '<span class="myd-wl-move-option__check">✓</span>' : ''}
          </button>
        `;
      })
      .join('');

    list.querySelectorAll('[data-myd-wl-move-to]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.getAttribute('data-myd-wl-move-to');
        moveProductToBoard(id, target);
        closeMoveSheet();
        if (state.tab === 'boards') renderBoards();
      });
    });

    move.hidden = false;
  }

  function closeMoveSheet() {
    const move = document.querySelector('[data-myd-wl-move-modal]');
    if (move) move.hidden = true;
  }

  function setTab(tab) {
    state.tab = tab;
    document.querySelectorAll('[data-myd-wl-tab]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.getAttribute('data-myd-wl-tab') === tab);
    });
    const items = document.querySelector('[data-myd-wl-panel="items"]');
    const boards = document.querySelector('[data-myd-wl-panel="boards"]');
    if (items) items.hidden = tab !== 'items';
    if (boards) boards.hidden = tab !== 'boards';
    if (tab === 'boards') renderBoards();
  }

  function updateCount() {
    const n = document.querySelectorAll('.iwishProducts > .iwishItem').length;
    const el = document.querySelector('[data-myd-wl-count]');
    if (!el) return;
    // Avoid flashing Items(0) while iWish is still hydrating
    if (!state.hydrated && n === 0) {
      el.textContent = '';
      return;
    }
    el.textContent = String(n);
  }

  function markHydrated() {
    state.hydrated = true;
    state.ready = true;
    updateCount();
    updateEmptyState();
  }

  function formatMoney(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    try {
      if (window.Shopify?.formatMoney) {
        const fmt = window.iWishData?.money_format || window.shopSettings?.moneyFormat || '₹ {{amount}}';
        return window.Shopify.formatMoney(n, fmt);
      }
    } catch (_) {
      /* fall through */
    }
    return `₹${Math.round(n / 100).toLocaleString('en-IN')}`;
  }

  async function fetchProduct(handle) {
    if (!handle) return null;
    if (productCache.has(handle)) return productCache.get(handle);
    const req = fetch(`/products/${encodeURIComponent(handle)}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
    productCache.set(handle, req);
    return req;
  }

  function ensureSearchJs() {
    if (customElements.get('myd-search-quick-add')) return Promise.resolve();
    if (searchJsPromise) return searchJsPromise;
    const src = window.MYD_WL_SEARCH_JS;
    if (!src) return Promise.resolve();
    searchJsPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('myd-search.js failed'));
      document.head.appendChild(s);
    }).catch(() => {
      searchJsPromise = null;
    });
    return searchJsPromise || Promise.resolve();
  }

  function pumpEnrich() {
    while (enrichActive < ENRICH_CONCURRENCY && enrichQueue.length) {
      const item = enrichQueue.shift();
      if (!item?.isConnected || item.dataset.mydWlEnriched === '1') continue;
      enrichActive += 1;
      enrichCard(item).finally(() => {
        enrichActive -= 1;
        pumpEnrich();
      });
    }
  }

  function queueEnrich(item) {
    if (!item || item.dataset.mydWlEnriched === '1' || item.dataset.mydWlEnrichQueued === '1') return;
    item.dataset.mydWlEnrichQueued = '1';
    enrichQueue.push(item);
    pumpEnrich();
  }

  function observeEnrich(item) {
    if (!item || item.dataset.mydWlEnriched === '1') return;
    if (!enrichObserver) {
      enrichObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            enrichObserver.unobserve(entry.target);
            queueEnrich(entry.target);
          });
        },
        { rootMargin: '180px 0px', threshold: 0.01 }
      );
    }
    enrichObserver.observe(item);
  }

  function withSilentPaint(fn) {
    state.painting = true;
    try {
      fn();
    } finally {
      // Allow nested MO microtasks to settle before re-enabling
      requestAnimationFrame(() => {
        state.painting = false;
      });
    }
  }

  function fitFromProduct(product) {
    if (!product) return '';
    const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    const fit = tags.map((t) => String(t).trim()).find((t) => /fit/i.test(t));
    return fit || '';
  }

  function isSoldOut(item, product) {
    if (item.querySelector('.product-soldout, .iwish-product-form.product-soldout')) return true;
    if (item.querySelector('.iwishBuyBtn[disabled]')) return true;
    if (!product?.variants?.length) return false;
    return product.variants.every((v) => !v.available);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function mountYmlCard(item, data) {
    let card = item.querySelector(':scope > .myd-search-card');
    if (!card) {
      card = document.createElement('article');
      card.className = 'myd-search-card';
      item.insertBefore(card, item.firstChild);
    }

    card.classList.toggle('is-sold-out', !!data.soldOut);
    if (data.handle) card.setAttribute('data-product-handle', data.handle);

    const imgSrc =
      data.imgSrc ||
      item.querySelector('.iwishImgWrap img')?.getAttribute('src') ||
      '';
    const imgAlt = data.title || item.querySelector('.iwishImgWrap img')?.getAttribute('alt') || '';

    let badges = '';
    if (data.soldOut) {
      badges += `<div class="myd-search-card__soldout">Sold Out</div>`;
    } else {
      if (data.discount >= 1) {
        badges += `<div class="myd-search-card__discount">${data.discount}% OFF</div>`;
      }
      if (data.fit) {
        badges += `<span class="myd-search-card__badge">${escapeHtml(data.fit)}</span>`;
      }
    }

    const action = data.soldOut
      ? `<a class="myd-search-card__notify" href="${escapeAttr(data.href)}" aria-label="Notify me">${ICONS.bell}</a>`
      : data.handle
        ? `<button type="button" class="myd-search-card__quick-add" data-myd-quick-add data-product-handle="${escapeAttr(data.handle)}" aria-label="Select your fit">${ICONS.plus}</button>`
        : '';

    card.innerHTML = `
      <div class="myd-search-card__media">
        <a href="${escapeAttr(data.href)}" class="myd-search-card__media-link" aria-label="${escapeAttr(data.title)}">
          ${imgSrc ? `<img class="myd-search-card__image" src="${escapeAttr(imgSrc)}" alt="${escapeAttr(imgAlt)}" loading="lazy">` : ''}
        </a>
        ${badges}
        <button type="button" class="myd-wl-move" aria-label="Move to board">${ICONS.board}</button>
        <button type="button" class="myd-wl-remove" aria-label="Remove">${ICONS.x}</button>
      </div>
      <div class="myd-search-card__body">
        <a href="${escapeAttr(data.href)}" class="myd-search-card__info">
          ${data.type ? `<p class="myd-search-card__type">${escapeHtml(data.type)}</p>` : ''}
          <h3 class="myd-search-card__title">${escapeHtml(data.title)}</h3>
        </a>
        ${action}
        <div class="myd-search-card__price">
          <span class="myd-search-card__price-current">${data.priceHtml || ''}</span>
          ${data.compareHtml ? `<span class="myd-search-card__price-compare">${data.compareHtml}</span>` : ''}
        </div>
      </div>
    `;

    const removeBtn = item.querySelector('.iwishRemoveBtn');
    const productId = productIdFromItem(item);
    card.querySelector('.myd-wl-remove')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (removeBtn) removeBtn.click();
      else item.remove();
      setTimeout(() => {
        updateCount();
        updateEmptyState();
        if (state.tab === 'boards') renderBoards();
      }, 50);
    });
    card.querySelector('.myd-wl-move')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openMoveSheet(productId);
    });
  }

  async function enrichCard(item) {
    if (item.dataset.mydWlEnriched === '1') return;
    const handle =
      item.dataset.productHandle ||
      handleFromHref(item.querySelector('.iwishImgWrap a')?.getAttribute('href'));
    if (!handle) {
      item.dataset.mydWlEnriched = '1';
      return;
    }
    const product = await fetchProduct(handle);
    if (!product || !item.isConnected) {
      item.dataset.mydWlEnriched = '1';
      return;
    }

    const href = item.querySelector('.iwishImgWrap a')?.getAttribute('href') || `/products/${handle}`;
    const soldOut = isSoldOut(item, product);
    const price = product.price;
    const compare = product.compare_at_price;
    const discount =
      compare && price && compare > price
        ? Math.round(((compare - price) * 100) / compare)
        : 0;
    const img =
      product.featured_image ||
      product.images?.[0]?.src ||
      product.images?.[0] ||
      item.querySelector('.iwishImgWrap img')?.getAttribute('src') ||
      '';

    withSilentPaint(() => {
      mountYmlCard(item, {
        handle,
        href,
        title: product.title || '',
        type: product.type || '',
        fit: fitFromProduct(product),
        priceHtml: escapeHtml(formatMoney(price)),
        compareHtml: compare && price && compare > price ? escapeHtml(formatMoney(compare)) : '',
        soldOut,
        discount,
        imgSrc: typeof img === 'string' ? img : '',
      });
    });
    item.dataset.mydWlEnriched = '1';
  }

  function transformCard(item) {
    if (item.dataset.mydWl === '1') {
      if (item.dataset.mydWlEnriched !== '1') observeEnrich(item);
      return;
    }
    item.dataset.mydWl = '1';

    const link = item.querySelector('.iwishImgWrap a, .iwishMeta-title a');
    const handle = handleFromHref(link?.getAttribute('href'));
    const href = link?.getAttribute('href') || '#';
    if (handle) item.dataset.productHandle = handle;

    const title =
      item.querySelector('.iwishMeta-title a, .iwishMeta-title')?.textContent?.trim() || '';
    const priceNode = item.querySelector('.iwishMeta-price');
    const priceHtml = priceNode ? priceNode.innerHTML : '';

    withSilentPaint(() => {
      mountYmlCard(item, {
        handle,
        href,
        title,
        type: '',
        fit: '',
        priceHtml,
        compareHtml: '',
        soldOut: isSoldOut(item, null),
        discount: 0,
        imgSrc: item.querySelector('.iwishImgWrap img')?.getAttribute('src') || '',
      });
    });

    // Enrich type / compare / fit only when near viewport (max 2 concurrent)
    observeEnrich(item);
  }

  function transformAllCards() {
    if (state.painting) return;
    document.querySelectorAll('.iwishProducts > .iwishItem').forEach(transformCard);
    updateCount();
    updateEmptyState();
  }

  function updateEmptyState() {
    const empty = document.querySelector('[data-myd-wl-empty]');
    const products = document.querySelector('.iwishProducts');
    if (!empty) return;
    const count = document.querySelectorAll('.iwishProducts > .iwishItem').length;
    const loggedIn = isLoggedIn();

    if (count > 0) {
      state.hydrated = true;
      empty.hidden = true;
      empty.classList.add('is-hidden');
      if (products) {
        products.hidden = false;
        products.style.display = '';
      }
      return;
    }

    // Don't flash empty UI while iWish products are still loading
    if (!state.hydrated) {
      empty.hidden = true;
      empty.classList.add('is-hidden');
      if (products) {
        products.hidden = false;
        products.style.display = '';
      }
      return;
    }

    empty.hidden = false;
    empty.classList.remove('is-hidden');
    if (products) {
      products.hidden = true;
      products.style.display = 'none';
    }

    if (loggedIn) {
      empty.innerHTML = `
        <div class="myd-wl-empty__icon">${ICONS.heart}</div>
        <h2 class="myd-wl-empty__title">Your Wishlist Is Empty</h2>
        <p class="myd-wl-empty__text">Save items you love to buy them later</p>
        <a class="myd-wl-btn" href="/collections/all">Start Shopping</a>
      `;
    } else {
      const login = `/account/login?return_to=${encodeURIComponent(returnTo())}`;
      empty.innerHTML = `
        <div class="myd-wl-empty__icon">${ICONS.heart}</div>
        <h2 class="myd-wl-empty__title">Login to View Your Wishlist</h2>
        <p class="myd-wl-empty__text">Save items you love to buy them later</p>
        <a class="myd-wl-btn" href="${login}">Log In / Sign Up</a>
      `;
    }
  }

  function openCreateModal(boardId) {
    state.editingBoardId = boardId || null;
    const modal = document.querySelector('[data-myd-wl-modal]');
    if (!modal) return;
    const title = modal.querySelector('[data-myd-wl-modal-title]');
    const text = modal.querySelector('[data-myd-wl-modal-text]');
    const input = modal.querySelector('[data-myd-wl-board-name]');
    const save = modal.querySelector('[data-myd-wl-board-save]');
    if (boardId) {
      const board = ensureDefaultBoard(readBoards()).find((b) => b.id === boardId);
      if (title) title.textContent = 'Rename Board';
      if (text) text.textContent = 'Enter a new name for your wishlist Board';
      if (input) input.value = board?.name || '';
      if (save) save.textContent = 'Save';
    } else {
      if (title) title.textContent = 'Create Your Board';
      if (text) text.textContent = 'Enter a name for your wishlist Board';
      if (input) input.value = '';
      if (save) save.textContent = 'Create';
    }
    modal.hidden = false;
    input?.focus();
  }

  function closeModal() {
    const modal = document.querySelector('[data-myd-wl-modal]');
    if (modal) modal.hidden = true;
    state.editingBoardId = null;
  }

  function saveBoardFromModal() {
    const input = document.querySelector('[data-myd-wl-board-name]');
    const name = (input?.value || '').trim();
    if (!name) {
      input?.focus();
      return;
    }
    let boards = ensureDefaultBoard(readBoards());
    if (state.editingBoardId) {
      boards = boards.map((b) => (b.id === state.editingBoardId ? { ...b, name } : b));
    } else {
      boards.push({ id: uid(), name, isDefault: false, productIds: [] });
    }
    writeBoards(boards);
    closeModal();
    renderBoards();
  }

  function setDefaultBoard(id) {
    let boards = ensureDefaultBoard(readBoards()).map((b) => ({
      ...b,
      isDefault: b.id === id,
    }));
    writeBoards(boards);
    renderBoards();
  }

  function deleteBoard(id) {
    let boards = ensureDefaultBoard(readBoards()).filter((b) => b.id !== id || b.isDefault);
    if (!boards.some((b) => b.isDefault) && boards[0]) boards[0].isDefault = true;
    writeBoards(boards);
    renderBoards();
  }

  function renderBoards() {
    const panel = document.querySelector('[data-myd-wl-panel="boards"]');
    if (!panel) return;

    const thumbs = collectWishlistThumbs();
    let boards = pruneBoardMembership(ensureDefaultBoard(readBoards()), thumbs.map((t) => t.id));
    writeBoards(boards);

    const customCount = boards.filter((b) => !b.isDefault).length;
    const defaultEmpty = !thumbs.length;

    // Empty boards experience when no items and no custom boards
    if (defaultEmpty && customCount === 0) {
      panel.innerHTML = `
        <div class="myd-wl-empty">
          <div class="myd-wl-empty__icon">${ICONS.grid}</div>
          <h2 class="myd-wl-empty__title">Manage your favourite items</h2>
          <button type="button" class="myd-wl-btn" data-myd-wl-open-create>Create Board</button>
        </div>
      `;
      panel.querySelector('[data-myd-wl-open-create]')?.addEventListener('click', () => openCreateModal());
      return;
    }

    const boardsHtml = boards
      .map((board) => {
        const boardThumbs = thumbsForBoard(board, thumbs, boards);
        const count = boardThumbs.length;
        const menuId = `menu-${board.id}`;
        return `
          <article class="myd-wl-board" data-board-id="${board.id}">
            <div class="myd-wl-board__head">
              <div>
                <div class="myd-wl-board__name-row">
                  <h3 class="myd-wl-board__name">${escapeHtml(board.name)}</h3>
                  ${board.isDefault ? '<span class="myd-wl-board__default">Default</span>' : ''}
                </div>
                <p class="myd-wl-board__count">${count} Item${count === 1 ? '' : 's'}</p>
              </div>
              <button type="button" class="myd-wl-board__menu-btn" data-myd-wl-menu-toggle aria-label="Board options">⋯</button>
              <div class="myd-wl-board__menu" id="${menuId}" hidden>
                ${board.isDefault ? '' : `<button type="button" data-myd-wl-set-default="${board.id}">Set as Default</button>`}
                <button type="button" data-myd-wl-rename="${board.id}">Rename</button>
                ${board.isDefault ? '' : `<button type="button" data-myd-wl-delete="${board.id}">Delete</button>`}
              </div>
            </div>
            ${
              boardThumbs.length
                ? `<div class="myd-wl-board__thumbs">${boardThumbs
                    .slice(0, 12)
                    .map(
                      (t) => `
                        <div class="myd-wl-board__thumb">
                          <a href="${t.href}"><img src="${t.src}" alt="${escapeAttr(t.alt)}" loading="lazy"></a>
                          <button type="button" class="myd-wl-board__thumb-move" data-myd-wl-move-product="${escapeAttr(t.id)}" aria-label="Move to board">${ICONS.board}</button>
                        </div>`
                    )
                    .join('')}</div>`
                : `<p class="myd-wl-board__empty-note">${
                    board.isDefault
                      ? 'Items not moved to a board show up here'
                      : 'No items yet — open Items and tap the folder icon to move products here'
                  }</p>`
            }
          </article>
        `;
      })
      .join('');

    panel.innerHTML = `
      <button type="button" class="myd-wl-boards-create" data-myd-wl-open-create>
        <span class="myd-wl-boards-create__plus">+</span>
        Create a board
      </button>
      ${boardsHtml}
      <div class="myd-wl-recs" data-myd-wl-recs hidden>
        <h3 class="myd-wl-recs__title">You may also like</h3>
        <div class="myd-wl-recs__scroller" data-myd-wl-recs-list></div>
      </div>
    `;

    panel.querySelector('[data-myd-wl-open-create]')?.addEventListener('click', () => openCreateModal());

    panel.querySelectorAll('[data-myd-wl-menu-toggle]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.stopPropagation();
        const menu = btn.parentElement?.querySelector('.myd-wl-board__menu');
        document.querySelectorAll('.myd-wl-board__menu').forEach((m) => {
          if (m !== menu) m.hidden = true;
        });
        if (menu) menu.hidden = !menu.hidden;
      });
    });

    panel.querySelectorAll('[data-myd-wl-set-default]').forEach((btn) => {
      btn.addEventListener('click', () => setDefaultBoard(btn.getAttribute('data-myd-wl-set-default')));
    });
    panel.querySelectorAll('[data-myd-wl-rename]').forEach((btn) => {
      btn.addEventListener('click', () => openCreateModal(btn.getAttribute('data-myd-wl-rename')));
    });
    panel.querySelectorAll('[data-myd-wl-delete]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (window.confirm('Delete this board?')) deleteBoard(btn.getAttribute('data-myd-wl-delete'));
      });
    });
    panel.querySelectorAll('[data-myd-wl-move-product]').forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        openMoveSheet(btn.getAttribute('data-myd-wl-move-product'));
      });
    });

    loadRecommendations();
  }

  async function loadRecommendations() {
    const wrap = document.querySelector('[data-myd-wl-recs]');
    const list = document.querySelector('[data-myd-wl-recs-list]');
    if (!wrap || !list) return;

    const first = collectWishlistThumbs()[0];
    const productId = first?.id;
    let products = [];

    try {
      if (productId) {
        const res = await fetch(
          `/recommendations/products.json?product_id=${encodeURIComponent(productId)}&limit=8&intent=related`
        );
        if (res.ok) {
          const data = await res.json();
          products = data.products || [];
        }
      }
      if (!products.length) {
        const res = await fetch('/collections/all/products.json?limit=8');
        if (res.ok) {
          const data = await res.json();
          products = data.products || [];
        }
      }
    } catch (_) {
      /* ignore */
    }

    if (!products.length) {
      wrap.hidden = true;
      return;
    }

    list.innerHTML = products
      .slice(0, 8)
      .map((p) => {
        const img =
          p.featured_image ||
          p.images?.[0]?.src ||
          p.images?.[0] ||
          '';
        const src = typeof img === 'string' ? img : img?.src || '';
        const url = p.url || `/products/${p.handle}`;
        return `
          <a class="myd-wl-recs__card" href="${url}">
            <img src="${src}" alt="${escapeAttr(p.title || '')}" loading="lazy">
            <p class="myd-wl-recs__card-title">${escapeHtml(p.title || '')}</p>
          </a>
        `;
      })
      .join('');
    wrap.hidden = false;
  }

  function observeProducts() {
    const products = document.querySelector('.iwishProducts');
    if (!products) return;
    let scheduled = false;
    const mo = new MutationObserver((mutations) => {
      if (state.painting) return;
      const addedItem = mutations.some((m) =>
        [...m.addedNodes].some(
          (n) =>
            n.nodeType === 1 &&
            (n.classList?.contains('iwishItem') || n.querySelector?.('.iwishItem'))
        )
      );
      if (!addedItem) return;
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        transformAllCards();
        if (document.querySelectorAll('.iwishProducts > .iwishItem').length) markHydrated();
      });
    });
    // Direct children only — skin markup must not re-trigger transforms
    mo.observe(products, { childList: true, subtree: false });
  }

  function hookIwishInit() {
    const prev = window.iWishPageinitFn;
    window.iWishPageinitFn = function () {
      try {
        if (typeof prev === 'function') prev.apply(this, arguments);
      } catch (_) {
        /* ignore */
      }
      transformAllCards();
      // iWish finished its page init — safe to show empty if still no items
      markHydrated();
    };
  }

  function boot() {
    document.body.classList.add('myd-wishlist-ui');
    const wrapper = document.querySelector('.iwishWrapper');
    if (!wrapper) return;
    injectShell(wrapper);
    hookIwishInit();
    observeProducts();
    transformAllCards();
    // If products already in DOM, hydrate immediately
    if (document.querySelectorAll('.iwishProducts > .iwishItem').length) {
      markHydrated();
    }
    // Fallback: if iWish never calls init / adds nothing, stop waiting
    setTimeout(() => {
      transformAllCards();
      markHydrated();
    }, 1800);
  }

  // Load size-sheet JS only on first + tap (keeps wishlist boot lean)
  document.addEventListener(
    'click',
    (event) => {
      const btn = event.target.closest?.('[data-myd-quick-add]');
      if (!btn || customElements.get('myd-search-quick-add')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      ensureSearchJs().then(() => customElements.whenDefined('myd-search-quick-add')).then(() => {
        requestAnimationFrame(() => {
          btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        });
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', () => {
    transformAllCards();
  });

  document.addEventListener('click', () => {
    document.querySelectorAll('.myd-wl-board__menu').forEach((m) => {
      m.hidden = true;
    });
  });
})();
